import { Heading } from './styles';

export default Heading;
